import { useGroupTranslator } from '../../../components/i18n/GroupTranslationContext';

/**
 * Simplified interface for toolbar item config
 */
type ToolbarItemConfig = {
    localeKey?: string;
    tooltipLocaleKey?: string;
    name?: string | null;
    tooltipText?: string;
};

/**
 * Hook to get translated toolbar tool name and tooltip from a toolbar item config.
 *
 * @param item - Toolbar item config object
 * @param nameOverride - Override for the tool name (optional)
 * @param tooltipOverride - Override for the tooltip text (optional)
 * @returns Object with translated toolName and tooltipText
 */
export const useToolbarItemTranslation = (
    item: ToolbarItemConfig | null | undefined,
    nameOverride?: string,
    tooltipOverride?: string,
): { toolName: string; tooltipText?: string } => {
    const translate = useGroupTranslator();

    const { localeKey, tooltipLocaleKey, name, tooltipText: itemTooltipText } = item ?? {};

    const toolNameFallback = nameOverride ?? name ?? '';

    const toolName = localeKey ? translate(localeKey) : toolNameFallback;

    const tooltipFallback = tooltipOverride ?? itemTooltipText;

    const tooltipText = tooltipLocaleKey ? translate(tooltipLocaleKey) : tooltipFallback;

    return { toolName, tooltipText };
};
